import { render } from "./homeSet.vue?vue&type=template&id=6c5b1240&scoped=true"
import script from "./homeSet.vue?vue&type=script&lang=js"
export * from "./homeSet.vue?vue&type=script&lang=js"

import "./homeSet.vue?vue&type=style&index=0&id=6c5b1240&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5b1240"]])

export default __exports__